var map = {
	"./smallCoinApng.png": 698485,
	"./卡牌反转-效果.png": 866360,
	"./卡牌消失-apng.png": 490996,
	"./进场条.png": 460045,
	"./选中发光-apng.png": 208870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421452;